import styled from 'styled-components';
import { rem } from 'polished';
import { VehiclePriceDetailsBlockStyled } from '../VehiclePriceDetailsBlockStyled';
export const VehiclePriceDetailsBlockStyledOVGB = styled(VehiclePriceDetailsBlockStyled)`
    .row {
        .rowTitle {
            font-size: ${rem('14px')};
        }

        .info,
        .infoOptions {
            font-size: ${rem('14px')};
            line-height: 1.43;
        }

        .infoOptions {
            .icon-wrapper svg {
                circle {
                    fill: black;
                    stroke: black;
                }
                line {
                    stroke: white;
                }
            }
        }
    }
`;
